import Kirana1 from "./kirana (1).webp";
import Kirana2 from "./kirana (2).webp";
import Kirana3 from "./kirana (3).webp";

const kirana = [Kirana1, Kirana2, Kirana3];

export default kirana;
